import cityMode from './cityMode';
import routeMode from './routeMode';
import stationMode from './stationMode';
import stateMode from './stateMode';
import zipMode from './zipMode';
import routeModeGreyhound from './routeModeGreyhound';
import stationModeGreyhound from './stationModeGreyhound';

const flavors = {
  cityMode,
  routeMode,
  stationMode,
  stateMode,
  zipMode,
  routeModeGreyhound,
  stationModeGreyhound,
};

export default flavors;
